import axios from "../../axios";

const getAdministrators = async function (accessToken,params = {}) {
    try {
        const response = await axios.post('admin/administration/getAdministrators', params ,{
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getAdministrators;
